import { MobilsTauletesProps } from './MobilsTauletes.types';
import __isEmpty from 'lodash/isEmpty';
// @ts-ignore
import Text from 'components/corporatiu/Text';
// @ts-ignore
import Titol from 'components/corporatiu/Titol';
// @ts-ignore
import Imatge from 'components/corporatiu/Imatge';
// @ts-ignore
import EnllacComponent from 'components/corporatiu/Enllac';
const Enllac: any = EnllacComponent;
import styles from './mobilstauletes.module.scss';

const MobilsTauletes = (props: Readonly<MobilsTauletesProps>) => {
    const { items, isLite = false } = props;

    return (
        <>
            {!props.isLite && (
                <>
                    <Titol titol={items?.titol} tipus='menu' tag='h1' estil='titolPagina' />
                    <Text text={items?.descripcio} />
                </>
            )}

            <div className={styles.mosaic}>
                {!__isEmpty(items) &&
                    items?.aplicacions
                        ?.filter((item) => !isLite || ['3Cat', 'CatRàdio'].includes(item.nom))
                        .map((item, index) => (
                            <div key={index}>
                                <div key={`notis-${index}`} className={styles.itemApp}>
                                    <>
                                        {(() => {
                                            const contingut = (
                                                <>
                                                    <Imatge
                                                        src={item.imatge}
                                                        loading='lazy'
                                                        width={130}
                                                        height={130}
                                                        alt={item.descripcio}
                                                        className={styles.imatgeApp}
                                                    ></Imatge>
                                                    <Text text={item.nom} tag='h3' />
                                                </>
                                            );
                                            return item.paginaApp ? (
                                                <Enllac href={item.paginaApp} title={item.nom}>
                                                    {contingut}
                                                </Enllac>
                                            ) : (
                                                contingut
                                            );
                                        })()}

                                        {items?.disponible && <Text text={items?.disponible} tag='p' />}
                                        {item.links && (
                                            <div className={styles.markets}>
                                                <Enllac href={item.links[0].url} title={item.links[0].nom}>
                                                    <Imatge
                                                        src={'https://statics.3cat.cat/recursos/ccma/apple-app-store.svg'}
                                                        loading='lazy'
                                                        width={88}
                                                        height={26}
                                                        alt={`${item.nom} ${item.links[0].nom}`}
                                                        aria-hidden='true'
                                                    ></Imatge>
                                                </Enllac>
                                                <Enllac href={item.links[1].url} title={item.links[1].nom}>
                                                    <Imatge
                                                        src={'https://statics.3cat.cat/recursos/ccma/google-play.svg'}
                                                        loading='lazy'
                                                        width={100}
                                                        height={26}
                                                        alt={`${item.nom} ${item.links[1].nom}`}
                                                        aria-hidden='true'
                                                    ></Imatge>
                                                </Enllac>
                                            </div>
                                        )}
                                    </>
                                </div>
                            </div>
                        ))}
            </div>

            {!props.isLite && (
                <>
                    <Text text={items?.configuracio} className='gapAfterRow' />
                    <Text text={items?.condicionsLegals} className='gapAfterRow' />
                    <Text text={items?.atencioAudiencia} className='gapAfterRow' />
                </>
            )}
        </>
    );
};

export default MobilsTauletes;
